import { MobileAccountBoxEquitySkeletonStyled, MobileAccountTopBoxStyled } from '../styled/MobileAccountBoxStyled';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAccountPlParamsSelector,
    getGetLiteTradeAccountMetrics,
} from '../../../../modules/LiteTrade/liteTradeSelectors';
import amountFormat from '../../../../utils/amountFormat';
import {
    MobileAccountBoxBlockPlSkeleton2Styled,
} from '../MobileAccountBoxBlockPl/styled/MobileAccountBoxBlockPl2Styled';
import type { IMobileAppRootState } from '../../../types/mobileAppState.t';
import UserStatusCircleProgress from '../../../../modules/UserStatus/UserStatusCircleProgress/UserStatusCircleProgress';
import { getAppUser } from '../../../../app/appSelectors';
import { locationSlice } from '../../../../modules/Location/locationReducer';
import { LOCATION_NAMES } from '../../../../modules/Location/locationConstants';
import classNames from 'classnames';

function MobileAccountTopBox() {
    const dispatch = useDispatch();
    const user = useSelector(getAppUser);
    const equity = useSelector((state: IMobileAppRootState) => {
        const metrics = getGetLiteTradeAccountMetrics(state);
        if (metrics)
            return metrics?.equity || 0;
        return NaN;
    });
    const {
        pl,
        show,
    } = useSelector(getAccountPlParamsSelector);
    const isNegativePl = pl < 0;
    const isNegativeEquity = equity < 0;

    const handleUserStatusClick = useCallback(() => {
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.USER_STATUSES }));
    }, [dispatch]);

    return <MobileAccountTopBoxStyled>
        <div/>
        <div className={'d-flex flex-column align-items-center gap-1'}>
            {isNaN(equity) && <MobileAccountBoxEquitySkeletonStyled className="wave-background"/>}
            {!isNaN(equity) && <span className={'fw700 f16 lh24'}>
                {isNegativeEquity && <span className={'text-secondary'}>-</span>}
                <span className={'text-secondary'}>$</span>
                <span>{amountFormat(Math.abs(equity), 2, null, false, { toFixed: true })}</span>
            </span>}
            {show && <span className={classNames('fw600 f14 lh20', { positive: !isNegativePl })}>
                {isNegativePl && <span className={'text-secondary'}>-</span>}
                <span className={classNames({ positive: !isNegativePl, 'text-secondary': isNegativePl })}>$</span>
                <span>{amountFormat(Math.abs(pl || 0), 2, null, false, { toFixed: true })}</span>
            </span>}
            {!show && <MobileAccountBoxBlockPlSkeleton2Styled/>}
        </div>
        <div onClick={handleUserStatusClick}>
            <UserStatusCircleProgress
                isShowUpdatedProgressAnimation
                progress={user.user_turnover_percent}
                userStatus={user.user_status}/>
        </div>
    </MobileAccountTopBoxStyled>;
}

export default MobileAccountTopBox;
